var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"content has-text-centered"},[_c('p',[_vm._v("© "+_vm._s(_vm.year)+" - Centro Social Paroquial da Brandoa. Todos os direitos reservados.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }